import { render } from "./Home.vue?vue&type=template&id=a16ba96c"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=a16ba96c&lang=css"

import exportComponent from "C:\\Users\\winky\\Downloads\\RecycleUniHack\\recycle-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__